<script>
export const group = 'Full'
</script>

<script setup>
import { ref, nextTick } from 'vue'
import Image from '../default/Image.vue'

defineProps({
  item: Object,
})

const show = ref(false)

const startTransition = async () => {
  await nextTick()
  show.value = true
}
</script>

<template>
  <Image v-show="show" :item="item" @load="startTransition" />
</template>
